'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _iconAliases = require('icons/iconAliases');

var _iconAliases2 = _interopRequireDefault(_iconAliases);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _iconName = require('../utils/propTypes/iconName');

var _IconConstants = require('./IconConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var sizeToRes = function sizeToRes(size) {
  return size <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
};

var getIconClassName = function getIconClassName(size, measuredRes) {
  var res = size != null ? sizeToRes(_IconConstants.ICON_SIZES[size] || size) : measuredRes;
  return 'private-icon__' + res;
};

var getComputedFontSize = function getComputedFontSize(size) {
  if (!size) return null;

  if (_IconConstants.ICON_SIZES.hasOwnProperty(size)) {
    return _IconConstants.ICON_SIZES[size];
  }

  return size;
};

var IconContent = _styledComponents2.default.span.withConfig({
  displayName: 'UIIcon__IconContent'
})(['font:inherit !important;&::before{content:"', '";}'], function (_ref) {
  var ligature = _ref.ligature;
  return ligature;
});

var getIconContent = (0, _memoize2.default)(function (ligature) {
  return _react2.default.createElement(IconContent, { 'aria-hidden': true, ligature: ligature });
});

var hasPingedNewRelic = false;

var UIIcon = (0, _memoWithDisplayName2.default)('UIIcon', function (props) {
  var className = props.className,
      color = props.color,
      name = props.name,
      screenReaderText = props.screenReaderText,
      style = props.style,
      size = props.size,
      rest = _objectWithoutProperties(props, ['className', 'color', 'name', 'screenReaderText', 'style', 'size']);

  var _useState = (0, _react.useState)('low'),
      _useState2 = _slicedToArray(_useState, 2),
      measuredRes = _useState2[0],
      setMeasuredRes = _useState2[1];

  var measureRef = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    if (size) return;

    // Measure the `fontSize` in the DOM to determine whether this is high- or low-res.
    var styles = getComputedStyle(measureRef.current, null);

    // Patch for Firefox < 62: https://bugzilla.mozilla.org/show_bug.cgi?id=1467722
    if (!styles) return;

    var newMeasuredRes = sizeToRes(parseInt(styles.fontSize, 10));
    if (newMeasuredRes !== measuredRes) setMeasuredRes(newMeasuredRes);
  });

  if (_iconAliases2.default[name]) {
    if (window.newrelic && !hasPingedNewRelic) {
      hasPingedNewRelic = true;
      window.newrelic.addPageAction('icon-alias', { alias: name });
    }
    if (process.env.NODE_ENV !== 'production') {
      _devLogger2.default.warn({
        message: 'UIIcon: "' + name + '" is a deprecated alias. Please use the canonical icon name.',
        key: 'UIIcon-' + name,
        url: 'https://tools.hubteamqa.com/ui-library/styles/icons'
      });
    }
  }

  var computedName = _iconAliases2.default[name] || name;
  var computedClassName = (0, _classnames2.default)('private-icon', getIconClassName(size, measuredRes), className);

  return _react2.default.createElement(
    'span',
    _extends({}, rest, {
      className: computedClassName,
      'data-icon-name': computedName,
      ref: measureRef,
      style: _extends({
        color: color
      }, style, {
        fontSize: getComputedFontSize(size)
      })
    }),
    getIconContent(computedName),
    screenReaderText &&
    // Spaces around screenReaderText prevents collisions withsiblingtext.
    _react2.default.createElement(
      'span',
      { className: 'sr-only' },
      ' ',
      screenReaderText,
      ' '
    )
  );
});

UIIcon.propTypes = {
  color: _propTypes2.default.string,
  name: (0, _iconName.getIconNamePropType)().isRequired,
  screenReaderText: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(Object.keys(_IconConstants.ICON_SIZES)), _propTypes2.default.number])
};

exports.default = UIIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/icon/UIIcon.js
// module id = 20
// module chunks = 177